(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1247],{

/***/ 10166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newStyled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(11463);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(48137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});




/***/ }),

/***/ 64852:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout-alert",
      function () {
        return __webpack_require__(28126);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./apis/queryFunctions/orderFuntions.js
var orderFuntions = __webpack_require__(37677);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
;// CONCATENATED MODULE: ./pages/checkout-alert/Error.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  width: 100%;\n  padding: 30px 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 58px;\n  height: 58px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  margin-bottom: 26px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 22px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Wrap = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var Icon = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var Error_Text = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var Error = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Error_Text, {
            children: props.message
        })
    });
};
Error.propTypes = {
    message: (prop_types_default()).string
};
/* harmony default export */ var checkout_alert_Error = (Error);

;// CONCATENATED MODULE: ./pages/checkout-alert/index.page.js





function index_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1185px;\n  margin: 0 auto;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-items: center;\n"
    ]);
    index_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_page_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* background-repeat: no-repeat; */\n  background-repeat: repeat-y;\n  /* background-size: contain; */\n  background-position: center;\n  padding: 40px 0 20px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex: 1;\n  margin-bottom: 10px;\n"
    ]);
    index_page_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_page_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 29px;\n  text-align: center;\n  font-size: 32px;\n"
    ]);
    index_page_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 49px;\n  text-align: center;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// import PropTypes from "prop-types";








var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(index_page_templateObject());
var Background = emotion_styled_browser_esm/* default.div */.Z.div(index_page_templateObject1());
var MainText = emotion_styled_browser_esm/* default.div */.Z.div(index_page_templateObject2());
var SoTien = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var uesStyle = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing.xl * 2,
            borderRadius: theme.radius.md,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
            border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[3])
        }, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            flexDirection: "column-reverse",
            padding: theme.spacing.xl
        }),
        button: {
            marginTop: theme.spacing.xl,
            padding: theme.spacing.md,
            backgroundColor: theme.colors.orange[5],
            color: theme.white,
            borderRadius: theme.radius.xs
        },
        buttonSecondary: {
            marginTop: theme.spacing.xl,
            padding: theme.spacing.md,
            backgroundColor: theme.colors.gray[5],
            color: theme.white,
            borderRadius: theme.radius.xs,
            marginRight: theme.spacing.md
        }
    };
});
function CheckoutAlert(param) {
    var location = param.location, apis = param.apis;
    var ref, ref1;
    // useEffect(() => {
    //   const goHome = setTimeout(() => GoHome(), 3000);
    //   return () => {
    //     clearTimeout(goHome);
    //   };
    // }, []);
    var router = (0,next_router.useRouter)();
    var classes = uesStyle().classes;
    var GoHome = function() {
        router.push("/mua-hang/san-pham?sort=newest");
    };
    var PaymentAgain = function() {
        window.location.href = "#/ho-so/quan-ly-don-hang";
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        isSuccess: null,
        amount: "0",
        message: ""
    }), 2), info = ref2[0], setinfo = ref2[1];
    var ref3 = (0,orderFuntions/* useFetchOrder */.K)(), info_order = ref3.data;
    // console.log(111111, info_order)
    var so_ct = info_order === null || info_order === void 0 ? void 0 : info_order.so_ct;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var isSuccess = (ref = router.query) === null || ref === void 0 ? void 0 : ref.isSuccess;
        var amount = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.amount;
        var message = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.message;
        var orderId = (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.orderId;
        var _id = (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4._id;
        var info = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, info), {
            isSuccess: isSuccess === "true",
            amount: Number(amount),
            message: String(message),
            email: String(((ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.email) || ""),
            orderId: orderId,
            _id: _id
        });
        setinfo(info);
    }, [
        router.query
    ]);
    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    //   let value = params.some_key; // "some_value"
    //   console.log("log amount");
    // if (
    //   !location?.state?.orderSuccess?.isSuccess &&
    //   !getParameterByName("isSuccess")
    // ) {
    //   return (
    //     <Container>
    //       <Wrapper>
    //         <Title>Trang bạn tìm không tồn tại</Title>
    //         <Box
    //           onClick={GoHome}
    //           display="flex"
    //           justifyContent="center"
    //           marginTop={1}
    //         >
    //           <BtnGoHome>Về trang chủ</BtnGoHome>
    //         </Box>
    //       </Wrapper>
    //     </Container>
    //   );
    // }
    console.log("\uD83D\uDE80 ~ file: index.page.js:132 ~ useEffect ~ orderId:", info);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            className: classes.wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                    children: info.isSuccess === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainText, {
                                children: "Đặt h\xe0ng th\xe0nh c\xf4ng"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                sx: {
                                    paddingTop: 10
                                },
                                children: "Cảm ơn v\xec đ\xe3 đặt h\xe0ng!"
                            }),
                            (info === null || info === void 0 ? void 0 : info.orderId) || (info === null || info === void 0 ? void 0 : info._id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    sx: {
                                        paddingTop: 10,
                                        textAlign: "center",
                                        flexDirection: "row",
                                        display: "flex"
                                    },
                                    children: [
                                        "M\xe3 đơn h\xe0ng l\xe0",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            sx: {
                                                fontWeight: "bold",
                                                paddingLeft: 5
                                            },
                                            children: so_ct || (info === null || info === void 0 ? void 0 : info.so_ct) || (info === null || info === void 0 ? void 0 : info.orderId) || (info === null || info === void 0 ? void 0 : info._id) || ""
                                        })
                                    ]
                                })
                            }),
                            (info === null || info === void 0 ? void 0 : info.amount) > 0 && !(location === null || location === void 0 ? void 0 : (ref = location.state) === null || ref === void 0 ? void 0 : (ref1 = ref.orderSuccess) === null || ref1 === void 0 ? void 0 : ref1.isCOD) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SoTien, {
                                children: [
                                    numeral_default()(info === null || info === void 0 ? void 0 : info.amount).format("0,0"),
                                    " đ"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                className: classes.button,
                                onClick: GoHome,
                                children: "Tiếp tục mua h\xe0ng"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_alert_Error, {
                                message: "Thanh to\xe1n kh\xf4ng th\xe0nh c\xf4ng"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                        className: (classes.button, classes.buttonSecondary),
                                        onClick: GoHome,
                                        children: "Về trang chủ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                        className: classes.button,
                                        onClick: PaymentAgain,
                                        children: "Thanh to\xe1n lại"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
CheckoutAlert.propTypes = {
    location: (prop_types_default()).object,
    apis: (prop_types_default()).object
};
/* harmony default export */ var index_page = (CheckoutAlert);


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(64852); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);